import { parseAmountToMinor } from "@themislex/shared";

/**
 * Parse a user-typed rupee amount ("12,345.50") into the major-unit number
 * the API schemas expect. Returns undefined for invalid/empty input.
 */
export function amountToNumber(input: string): number | undefined {
  const minor = parseAmountToMinor(input);
  return minor === null ? undefined : minor / 100;
}

export function formatAmountInput(value: number): string {
  return (value / 100).toFixed(2);
}
